/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { useForm, useFieldArray } from "react-hook-form";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import { INSURANCE_TYPE, insuranceDefault } from "../constants";

export default function Insurance({
  onPrevStep,
  onNextStep,
  currencies,
  insuranceLimits,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);

  const {
    handleSubmit,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: insuranceLimits
      ? { ...insuranceDefault, insuranceLimits }
      : { ...insuranceDefault },
  });

  const generalFieldProps = { control, errors };

  const formValidationRules = {
    type: { required: "Please Select Type" },
    currency: { required: "Please Select Currency" },
    pavement: {
      required: "Please Add Pavement",
      validate: (value) => {
        if (!value || value === "0") return "Please Add Pavement";
        return true;
      },
    },
    van: {
      required: "Please Add Van",
      validate: (value) => {
        if (!value || value === "0") return "Please Add Van";
        return true;
      },
    },
    bag: {
      required: "Please Add Bag",
      validate: (value) => {
        if (!value || value === "0") return "Please Add Bag";
        return true;
      },
    },
  };

  const { fields: insuranceLimitFields, remove: insuranceLimitRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "insuranceLimits",
    });
  useEffect(() => {
    if (addData) addData([...insuranceLimitFields]);
  }, [watch("insuranceLimits")]);

  const submitInfo = (data) => {
    const _data = { ...data };
    const _fields = [...insuranceLimitFields];
    const insuranceLimitObj = {
      type: _data.type,
      currency: _data.currency,
      pavement: _data.pavement,
      van: _data.van,
      bag: _data.bag,
    };

    if (currentEditing !== null) {
      _fields[currentEditing] = { ...insuranceLimitObj };
      setCurrentEditing(null);
    } else {
      _fields.push({ ...insuranceLimitObj });
    }
    reset({ ...insuranceDefault, insuranceLimits: _fields });
  };

  const cancelEditing = () => {
    setCurrentEditing(null);
    const _fields = [...insuranceLimitFields];
    reset({ ...insuranceDefault, insuranceLimits: _fields });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Insurance Limit"
          cursor="pointer"
          onClick={() => {
            reset({ ...dataItem, insuranceLimits: [...insuranceLimitFields] });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Insurance Limit"
          cursor="pointer"
          onClick={() => {
            insuranceLimitRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };

  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Insurance Limit</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button
              type="button"
              onClick={() => onPrevStep(insuranceLimitFields)}
            >
              Back
            </Button>
            <Button
              type="button"
              onClick={() => onNextStep(insuranceLimitFields)}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Insurance Type"
        name="type"
        id="id"
        text="text"
        data={INSURANCE_TYPE || []}
        placeholder="Select Insurance Type"
        rules={formValidationRules.type}
        dropdownProps={{ filterable: false }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        rules={formValidationRules.currency}
        dropdownProps={{ filterable: true }}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Pavement"
        name="pavement"
        rules={formValidationRules.pavement}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Van"
        name="van"
        rules={formValidationRules.van}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Bag"
        name="bag"
        rules={formValidationRules.bag}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button type="button" onClick={cancelEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update" : "Add"}
        </Button>
      </div>

      <Grid data={insuranceLimitFields}>
        <GridColumn field="type.text" title="Insurance Type" />
        <GridColumn field="currency.name" title="Currency" />
        <GridColumn field="pavement" title="Pavement" />
        <GridColumn field="van" title="Van" />
        <GridColumn field="bag" title="Bag" />

        <GridColumn title="Edit" width="80" cell={editCell} />
        <GridColumn title="Delete" width="80" cell={deleteCell} />
      </Grid>
    </form>
  );
}
